export default "__VITE_ASSET__4d7f62f6__"